module.exports = "/images/_/_/_/_/build/resources/js/src/assets/images/icons/star.svg";